// Country sample data - 54 countries across 7 continents
// Flag images from flagcdn.com (free flag CDN)

export const CONTINENTS = [
  {
    id: "africa",
    name: "Africa",
    emoji: "🦁",
    color: "#F4A261",
    fact: "Africa is the second largest continent. It has the world's longest river — the Nile!",
    countries: 54,
  },
  {
    id: "antarctica",
    name: "Antarctica",
    emoji: "🐧",
    color: "#7BCFC9",
    fact: "Antarctica is the coldest place on Earth. Penguins live here!",
    countries: 0,
  },
  {
    id: "asia",
    name: "Asia",
    emoji: "🐼",
    color: "#FFD166",
    fact: "Asia is the biggest continent. It has the tallest mountain — Mount Everest!",
    countries: 48,
  },
  {
    id: "europe",
    name: "Europe",
    emoji: "🏰",
    color: "#48A9A6",
    fact: "Europe has castles, beaches, and lots of yummy food like pasta and pastries!",
    // Includes 44 UN member states + Vatican City (observer) + Kosovo
    // (partial recognition) — 46 European countries & territories total.
    countries: 46,
  },
  {
    id: "north-america",
    name: "North America",
    emoji: "🗽",
    color: "#FF8E72",
    fact: "North America has big cities, huge forests, and the famous Grand Canyon!",
    countries: 23,
  },
  {
    id: "oceania",
    name: "Oceania",
    emoji: "🦘",
    color: "#9F89CC",
    fact: "Oceania has thousands of islands and animals like kangaroos and koalas!",
    countries: 14,
  },
  {
    id: "south-america",
    name: "South America",
    emoji: "🦜",
    color: "#90BE6D",
    fact: "South America has the Amazon — the biggest rainforest in the world!",
    countries: 12,
  },
];

// Each country has: code, name, continent, capital, language, hello (greeting),
// funFact (1-liner kid fact), landmark, plus richer fields:
//   currency  — Money used, with symbol when handy.
//   animal    — National animal (or representative) with emoji.
//   food      — Famous dish with emoji.
//   population— Kid-friendly approximate ("67 million people").
//   moreFacts — Extra 1-2 short fun facts shown on the detail page.
const _CORE_COUNTRIES = [
  // Europe
  { code: "fr", name: "France", continent: "europe", capital: "Paris", language: "French", hello: "Bonjour",
    funFact: "France has a giant iron tower called the Eiffel Tower!", landmark: "Eiffel Tower",
    currency: "Euro €", animal: "Gallic Rooster 🐓", food: "Croissant 🥐", population: "68 million people",
    moreFacts: ["French is spoken in 29 countries!", "Paris means 'City of Lights'."] },
  { code: "gb", name: "United Kingdom", continent: "europe", capital: "London", language: "English", hello: "Hello",
    funFact: "The UK has a giant clock called Big Ben!", landmark: "Big Ben",
    currency: "Pound £", animal: "Lion 🦁", food: "Fish & Chips 🐟🍟", population: "67 million people",
    moreFacts: ["The UK has 4 lands: England, Scotland, Wales & Northern Ireland.", "Double-decker red buses are everywhere!"] },
  { code: "it", name: "Italy", continent: "europe", capital: "Rome", language: "Italian", hello: "Ciao",
    funFact: "Italy is shaped like a boot and gave us pizza!", landmark: "Colosseum",
    currency: "Euro €", animal: "Wolf 🐺", food: "Pizza 🍕", population: "59 million people",
    moreFacts: ["Italy has the most volcanoes in Europe.", "Gelato was invented here!"] },
  { code: "es", name: "Spain", continent: "europe", capital: "Madrid", language: "Spanish", hello: "Hola",
    funFact: "Spain has a yummy dish called paella with rice and seafood!", landmark: "Sagrada Familia",
    currency: "Euro €", animal: "Bull 🐂", food: "Paella 🥘", population: "48 million people",
    moreFacts: ["Spain has more beaches than days in a year!", "Flamenco is a famous Spanish dance."] },
  { code: "de", name: "Germany", continent: "europe", capital: "Berlin", language: "German", hello: "Hallo",
    funFact: "Germany has fairy-tale castles in the mountains!", landmark: "Neuschwanstein Castle",
    currency: "Euro €", animal: "Eagle 🦅", food: "Pretzel 🥨", population: "84 million people",
    moreFacts: ["Germany has over 1,500 different types of sausage!", "The Brothers Grimm wrote fairy tales here."] },
  { code: "gr", name: "Greece", continent: "europe", capital: "Athens", language: "Greek", hello: "Geia sou",
    funFact: "Greece has bright blue and white houses by the sea!", landmark: "Parthenon",
    currency: "Euro €", animal: "Dolphin 🐬", food: "Gyros 🥙", population: "10 million people",
    moreFacts: ["The Olympics started here long ago!", "Greece has more than 2,000 islands."] },
  { code: "nl", name: "Netherlands", continent: "europe", capital: "Amsterdam", language: "Dutch", hello: "Hallo",
    funFact: "The Netherlands has windmills and lots of tulips!", landmark: "Windmills",
    currency: "Euro €", animal: "Cow 🐄", food: "Stroopwafel 🍪", population: "18 million people",
    moreFacts: ["There are more bikes than people here!", "Most of the country is below sea level."] },
  { code: "se", name: "Sweden", continent: "europe", capital: "Stockholm", language: "Swedish", hello: "Hej",
    funFact: "Sweden has long sunny days in summer and cozy snowy winters!", landmark: "Vasa Museum",
    currency: "Krona kr", animal: "Moose 🫎", food: "Meatballs 🍲", population: "11 million people",
    moreFacts: ["IKEA furniture comes from Sweden!", "ABBA, the music band, is Swedish too."] },
  { code: "no", name: "Norway", continent: "europe", capital: "Oslo", language: "Norwegian", hello: "Hei",
    funFact: "Norway has glowing northern lights dancing in the sky!", landmark: "Geirangerfjord",
    currency: "Krone kr", animal: "Reindeer 🦌", food: "Lutefisk 🐟", population: "5 million people",
    moreFacts: ["Vikings sailed from Norway long ago.", "Skiing was invented here!"] },
  { code: "pt", name: "Portugal", continent: "europe", capital: "Lisbon", language: "Portuguese", hello: "Olá",
    funFact: "Portugal has yummy custard tarts called pastéis de nata!", landmark: "Belém Tower",
    currency: "Euro €", animal: "Rooster 🐓", food: "Pastel de Nata 🍮", population: "10 million people",
    moreFacts: ["Portugal is one of the oldest countries in Europe.", "Surfers come for the BIG waves here!"] },
  { code: "pl", name: "Poland", continent: "europe", capital: "Warsaw", language: "Polish", hello: "Cześć",
    funFact: "Poland has a 700-year-old salt mine you can visit!", landmark: "Wawel Castle",
    currency: "Złoty zł", animal: "White-tailed Eagle 🦅", food: "Pierogi 🥟", population: "37 million people",
    moreFacts: ["European bison roam the forests here.", "Pierogi are little dumplings — yum!"] },
  { code: "ru", name: "Russia", continent: "europe", capital: "Moscow", language: "Russian", hello: "Privet",
    funFact: "Russia is the biggest country in the world!", landmark: "Saint Basil's Cathedral",
    currency: "Ruble ₽", animal: "Brown Bear 🐻", food: "Borscht 🥣", population: "144 million people",
    moreFacts: ["Russia spans 11 time zones!", "Lake Baikal is the deepest lake on Earth."] },
  { code: "ch", name: "Switzerland", continent: "europe", capital: "Bern", language: "German", hello: "Grüezi",
    funFact: "Switzerland makes yummy chocolate and tasty cheese!", landmark: "Matterhorn",
    currency: "Franc CHF", animal: "Saint Bernard Dog 🐕", food: "Fondue 🧀", population: "9 million people",
    moreFacts: ["Switzerland has 4 official languages!", "It is home to the Alps mountains."] },

  // Asia
  { code: "in", name: "India", continent: "asia", capital: "New Delhi", language: "Hindi", hello: "Namaste",
    funFact: "India has a beautiful white palace called the Taj Mahal!", landmark: "Taj Mahal",
    currency: "Rupee ₹", animal: "Bengal Tiger 🐯", food: "Curry & Naan 🍛", population: "1.4 billion people",
    moreFacts: ["India invented the number zero!", "Chess and yoga were born here too."] },
  { code: "cn", name: "China", continent: "asia", capital: "Beijing", language: "Mandarin", hello: "Nǐ hǎo",
    funFact: "The Great Wall of China is over 13,000 miles long — the longest wall ever built!", landmark: "Great Wall of China",
    currency: "Yuan ¥", animal: "Giant Panda 🐼", food: "Dumplings 🥟", population: "1.4 billion people",
    moreFacts: ["Pandas live only in China.", "Paper, ice cream and noodles were invented here."] },
  { code: "jp", name: "Japan", continent: "asia", capital: "Tokyo", language: "Japanese", hello: "Konnichiwa",
    funFact: "Japan has cherry blossom trees that bloom pink in spring!", landmark: "Mount Fuji",
    currency: "Yen ¥", animal: "Red-crowned Crane 🦩", food: "Sushi 🍣", population: "125 million people",
    moreFacts: ["Japan has bullet trains called Shinkansen.", "It is made of 6,800 islands!"] },
  { code: "kr", name: "South Korea", continent: "asia", capital: "Seoul", language: "Korean", hello: "Annyeong",
    funFact: "Korea is famous for K-pop music and yummy kimchi!", landmark: "Gyeongbokgung Palace",
    currency: "Won ₩", animal: "Siberian Tiger 🐅", food: "Kimchi 🥬", population: "52 million people",
    moreFacts: ["K-pop bands like BTS and BLACKPINK are from Korea!", "Korean BBQ is grilled at your table."] },
  { code: "th", name: "Thailand", continent: "asia", capital: "Bangkok", language: "Thai", hello: "Sawasdee",
    funFact: "Thailand has golden temples and friendly elephants!", landmark: "Grand Palace",
    currency: "Baht ฿", animal: "Asian Elephant 🐘", food: "Pad Thai 🍜", population: "70 million people",
    moreFacts: ["Thailand means 'Land of the Free'.", "It has over 35,000 temples!"] },
  { code: "ae", name: "United Arab Emirates", continent: "asia", capital: "Abu Dhabi", language: "Arabic", hello: "Marhaba",
    funFact: "Dubai has the tallest building in the world — the Burj Khalifa!", landmark: "Burj Khalifa",
    currency: "Dirham د.إ", animal: "Arabian Oryx 🦌", food: "Shawarma 🌯", population: "10 million people",
    moreFacts: ["The UAE has fancy hotels in the shape of a sail.", "Camels race here just like horses!"] },
  { code: "sa", name: "Saudi Arabia", continent: "asia", capital: "Riyadh", language: "Arabic", hello: "Marhaba",
    funFact: "Saudi Arabia is home to the world's largest sand desert!", landmark: "Edge of the World",
    currency: "Riyal ﷼", animal: "Arabian Horse 🐎", food: "Kabsa 🍚", population: "37 million people",
    moreFacts: ["The Rub' al Khali desert is the largest sand desert.", "Dates grow here — sweet and yummy!"] },
  { code: "id", name: "Indonesia", continent: "asia", capital: "Jakarta", language: "Indonesian", hello: "Halo",
    funFact: "Indonesia is made of more than 17,000 islands!", landmark: "Borobudur Temple",
    currency: "Rupiah Rp", animal: "Komodo Dragon 🦎", food: "Nasi Goreng 🍛", population: "278 million people",
    moreFacts: ["Komodo dragons are the world's biggest lizards.", "Bali is a famous Indonesian island."] },
  { code: "vn", name: "Vietnam", continent: "asia", capital: "Hanoi", language: "Vietnamese", hello: "Xin chào",
    funFact: "Vietnam has Ha Long Bay with thousands of tall rock islands!", landmark: "Ha Long Bay",
    currency: "Dong ₫", animal: "Water Buffalo 🐃", food: "Pho 🍜", population: "100 million people",
    moreFacts: ["People wear cone-shaped hats called nón lá.", "Pho is a tasty noodle soup."] },
  { code: "ph", name: "Philippines", continent: "asia", capital: "Manila", language: "Filipino", hello: "Kumusta",
    funFact: "The Philippines has over 7,000 islands and friendly people!", landmark: "Chocolate Hills",
    currency: "Peso ₱", animal: "Carabao 🐃", food: "Adobo 🍗", population: "117 million people",
    moreFacts: ["The Chocolate Hills turn brown like chocolate in dry season!", "Jeepneys are colorful buses here."] },
  { code: "il", name: "Israel", continent: "asia", capital: "Jerusalem", language: "Hebrew", hello: "Shalom",
    funFact: "Israel has the salty Dead Sea where you can float on the water!", landmark: "Dome of the Rock",
    currency: "Shekel ₪", animal: "Israeli Gazelle 🦌", food: "Falafel 🧆", population: "9 million people",
    moreFacts: ["The Dead Sea is so salty fish can't live in it!", "Jerusalem is sacred to three religions."] },
  { code: "sg", name: "Singapore", continent: "asia", capital: "Singapore", language: "English", hello: "Hello",
    funFact: "Singapore has giant tree-shaped gardens that light up at night!", landmark: "Marina Bay Sands",
    currency: "Dollar S$", animal: "Lion 🦁", food: "Chili Crab 🦀", population: "6 million people",
    moreFacts: ["The whole country is one big city!", "Its symbol is the Merlion — half lion, half fish."] },
  { code: "tr", name: "Turkey", continent: "asia", capital: "Ankara", language: "Turkish", hello: "Merhaba",
    funFact: "Turkey has hot air balloons floating over magical rock chimneys!", landmark: "Hagia Sophia",
    currency: "Lira ₺", animal: "Grey Wolf 🐺", food: "Kebab 🍢", population: "85 million people",
    moreFacts: ["Turkey sits in BOTH Europe and Asia!", "Tulips are originally from here."] },
  { code: "ir", name: "Iran", continent: "asia", capital: "Tehran", language: "Persian", hello: "Salam",
    funFact: "Iran has colorful mosques that shine like rainbows in the sun!", landmark: "Nasir al-Mulk Mosque",
    currency: "Rial ﷼", animal: "Persian Leopard 🐆", food: "Kebab & Saffron Rice 🍚", population: "89 million people",
    moreFacts: ["Persian carpets are world famous.", "Iran has tall snowy mountains AND a hot desert."] },

  // Africa
  { code: "eg", name: "Egypt", continent: "africa", capital: "Cairo", language: "Arabic", hello: "Marhaba",
    funFact: "Egypt has giant pyramids that are thousands of years old!", landmark: "Pyramids of Giza",
    currency: "Pound E£", animal: "Camel 🐪", food: "Koshari 🍚", population: "112 million people",
    moreFacts: ["The Nile is the longest river in the world.", "Ancient Egyptians invented hieroglyphic writing."] },
  { code: "za", name: "South Africa", continent: "africa", capital: "Pretoria", language: "Zulu", hello: "Sawubona",
    funFact: "South Africa has lions, elephants, and big safaris!", landmark: "Table Mountain",
    currency: "Rand R", animal: "Springbok 🦌", food: "Bobotie 🍲", population: "60 million people",
    moreFacts: ["South Africa has 11 official languages.", "The 'Big Five' animals live here."] },
  { code: "ke", name: "Kenya", continent: "africa", capital: "Nairobi", language: "Swahili", hello: "Jambo",
    funFact: "Kenya has the Maasai Mara where you can see zebras and giraffes!", landmark: "Mount Kenya",
    currency: "Shilling KSh", animal: "Lion 🦁", food: "Ugali 🌽", population: "55 million people",
    moreFacts: ["Marathon champions train here in the high mountains.", "Kenya has flamingos that turn lakes pink!"] },
  { code: "ma", name: "Morocco", continent: "africa", capital: "Rabat", language: "Arabic", hello: "Salam",
    funFact: "Morocco has colorful markets called souks and tasty mint tea!", landmark: "Hassan II Mosque",
    currency: "Dirham د.م.", animal: "Barbary Lion 🦁", food: "Tagine 🍲", population: "37 million people",
    moreFacts: ["You can ride camels across the Sahara desert here!", "Houses in Chefchaouen are painted bright blue."] },
  { code: "ng", name: "Nigeria", continent: "africa", capital: "Abuja", language: "English", hello: "Hello",
    funFact: "Nigeria has the most people of any country in Africa!", landmark: "Zuma Rock",
    currency: "Naira ₦", animal: "Eagle 🦅", food: "Jollof Rice 🍚", population: "224 million people",
    moreFacts: ["Nollywood movies are made here.", "Nigeria has more than 500 languages!"] },
  { code: "et", name: "Ethiopia", continent: "africa", capital: "Addis Ababa", language: "Amharic", hello: "Selam",
    funFact: "Ethiopia is where coffee was first discovered long ago!", landmark: "Rock Churches of Lalibela",
    currency: "Birr Br", animal: "Walia Ibex 🐐", food: "Injera 🥞", population: "126 million people",
    moreFacts: ["Ethiopia has its own alphabet and calendar.", "It is one of the oldest countries in the world."] },
  { code: "gh", name: "Ghana", continent: "africa", capital: "Accra", language: "English", hello: "Akwaaba",
    funFact: "Ghana is famous for kente cloth in bright rainbow patterns!", landmark: "Cape Coast Castle",
    currency: "Cedi ₵", animal: "African Elephant 🐘", food: "Fufu 🍲", population: "34 million people",
    moreFacts: ["Ghana means 'Warrior King'.", "Akwaaba means 'Welcome!'"] },
  { code: "tz", name: "Tanzania", continent: "africa", capital: "Dodoma", language: "Swahili", hello: "Jambo",
    funFact: "Tanzania has Mount Kilimanjaro — the tallest mountain in Africa!", landmark: "Mount Kilimanjaro",
    currency: "Shilling TSh", animal: "Giraffe 🦒", food: "Ugali & Nyama Choma 🥩", population: "65 million people",
    moreFacts: ["Zanzibar is a famous spicy island here.", "The Serengeti has the biggest animal migration on Earth."] },
  { code: "sn", name: "Senegal", continent: "africa", capital: "Dakar", language: "French", hello: "Bonjour",
    funFact: "Senegal has a pink lake that really looks pink!", landmark: "Lake Retba",
    currency: "CFA Franc", animal: "Lion 🦁", food: "Thieboudienne 🍚🐟", population: "17 million people",
    moreFacts: ["The pink color of Lake Retba comes from tiny algae!", "Wrestling is the most popular sport."] },

  // North America
  { code: "us", name: "United States", continent: "north-america", capital: "Washington D.C.", language: "English", hello: "Hello",
    funFact: "The USA has the Statue of Liberty holding a torch high!", landmark: "Statue of Liberty",
    currency: "Dollar $", animal: "Bald Eagle 🦅", food: "Burger & Fries 🍔🍟", population: "335 million people",
    moreFacts: ["The USA has 50 states.", "The Grand Canyon is so big you can see it from space!"] },
  { code: "ca", name: "Canada", continent: "north-america", capital: "Ottawa", language: "English", hello: "Hello",
    funFact: "Canada has yummy maple syrup and snowy mountains!", landmark: "CN Tower",
    currency: "Dollar C$", animal: "Beaver 🦫", food: "Poutine 🍟🧀", population: "40 million people",
    moreFacts: ["Canada has more lakes than the rest of the world combined!", "Ice hockey was invented here."] },
  { code: "mx", name: "Mexico", continent: "north-america", capital: "Mexico City", language: "Spanish", hello: "Hola",
    funFact: "Mexico has ancient pyramids built by the Mayans!", landmark: "Chichen Itza",
    currency: "Peso $", animal: "Golden Eagle 🦅", food: "Tacos 🌮", population: "129 million people",
    moreFacts: ["Chocolate was first made in Mexico from cocoa beans.", "Day of the Dead is a colorful festival."] },
  { code: "cu", name: "Cuba", continent: "north-america", capital: "Havana", language: "Spanish", hello: "Hola",
    funFact: "Cuba has colorful old cars and beautiful beaches!", landmark: "Old Havana",
    currency: "Peso CUP", animal: "Cuban Trogon 🐦", food: "Ropa Vieja 🍖", population: "11 million people",
    moreFacts: ["Salsa music started here!", "Cuba is the biggest island in the Caribbean."] },
  { code: "jm", name: "Jamaica", continent: "north-america", capital: "Kingston", language: "English", hello: "Hello",
    funFact: "Jamaica is the home of reggae music and sunny beaches!", landmark: "Dunn's River Falls",
    currency: "Dollar J$", animal: "Doctor Bird 🐦", food: "Jerk Chicken 🍗", population: "3 million people",
    moreFacts: ["Bob Marley, the reggae king, was Jamaican.", "Usain Bolt, the fastest runner, is from Jamaica."] },
  { code: "cr", name: "Costa Rica", continent: "north-america", capital: "San José", language: "Spanish", hello: "Hola",
    funFact: "Costa Rica has rainforests full of monkeys and colorful frogs!", landmark: "Arenal Volcano",
    currency: "Colón ₡", animal: "Sloth 🦥", food: "Gallo Pinto 🍚🫘", population: "5 million people",
    moreFacts: ["No army here — they use the money for schools!", "5% of all Earth's animals live in Costa Rica."] },
  { code: "pa", name: "Panama", continent: "north-america", capital: "Panama City", language: "Spanish", hello: "Hola",
    funFact: "Panama has a big canal where huge ships sail between two oceans!", landmark: "Panama Canal",
    currency: "Balboa B/.", animal: "Harpy Eagle 🦅", food: "Sancocho 🍲", population: "4 million people",
    moreFacts: ["You can see the sunrise on the Pacific AND sunset on the Atlantic in the same day!", "The Panama hat is actually from... Ecuador. Funny!"] },

  // South America
  { code: "br", name: "Brazil", continent: "south-america", capital: "Brasília", language: "Portuguese", hello: "Olá",
    funFact: "Brazil has the giant Amazon rainforest full of cool animals!", landmark: "Christ the Redeemer",
    currency: "Real R$", animal: "Jaguar 🐆", food: "Feijoada 🍛", population: "216 million people",
    moreFacts: ["Brazil has won the World Cup 5 times — most ever!", "Carnival is the biggest party on Earth."] },
  { code: "ar", name: "Argentina", continent: "south-america", capital: "Buenos Aires", language: "Spanish", hello: "Hola",
    funFact: "Argentina is the home of fun dancing called tango!", landmark: "Iguazu Falls",
    currency: "Peso $", animal: "Puma 🐆", food: "Asado (BBQ) 🥩", population: "46 million people",
    moreFacts: ["Iguazu Falls is bigger than Niagara Falls!", "Lionel Messi, the soccer star, is Argentine."] },
  { code: "pe", name: "Peru", continent: "south-america", capital: "Lima", language: "Spanish", hello: "Hola",
    funFact: "Peru has the lost city of Machu Picchu in the mountains!", landmark: "Machu Picchu",
    currency: "Sol S/", animal: "Llama 🦙", food: "Ceviche 🍤", population: "34 million people",
    moreFacts: ["Llamas help carry things up the steep mountains.", "The Andes mountains run all through Peru."] },
  { code: "co", name: "Colombia", continent: "south-america", capital: "Bogotá", language: "Spanish", hello: "Hola",
    funFact: "Colombia grows yummy coffee and beautiful flowers!", landmark: "Cocora Valley",
    currency: "Peso COP", animal: "Andean Condor 🦅", food: "Arepa 🌽", population: "52 million people",
    moreFacts: ["Colombia has the world's tallest palm trees.", "It is the second most flower-growing country!"] },
  { code: "cl", name: "Chile", continent: "south-america", capital: "Santiago", language: "Spanish", hello: "Hola",
    funFact: "Chile is a super long, skinny country next to big mountains!", landmark: "Easter Island",
    currency: "Peso CLP", animal: "Andean Condor 🦅", food: "Empanadas 🥟", population: "19 million people",
    moreFacts: ["Chile has the driest desert on Earth — the Atacama.", "Mysterious giant stone heads sit on Easter Island."] },
  { code: "ve", name: "Venezuela", continent: "south-america", capital: "Caracas", language: "Spanish", hello: "Hola",
    funFact: "Venezuela has Angel Falls — the tallest waterfall in the world!", landmark: "Angel Falls",
    currency: "Bolívar Bs.", animal: "Troupial 🐦", food: "Arepa 🌽", population: "29 million people",
    moreFacts: ["Angel Falls is taller than 3 Eiffel Towers stacked!", "Lightning storms in Lake Maracaibo light up nightly."] },

  // Oceania
  { code: "au", name: "Australia", continent: "oceania", capital: "Canberra", language: "English", hello: "G'day",
    funFact: "Australia has kangaroos that hop and koalas that hug trees!", landmark: "Sydney Opera House",
    currency: "Dollar A$", animal: "Kangaroo 🦘", food: "Vegemite Toast 🍞", population: "26 million people",
    moreFacts: ["Australia is a country, an island AND a continent!", "The Great Barrier Reef is the biggest coral reef in the world."] },
  { code: "nz", name: "New Zealand", continent: "oceania", capital: "Wellington", language: "English", hello: "Kia ora",
    funFact: "New Zealand has green hills where the Hobbit movies were filmed!", landmark: "Milford Sound",
    currency: "Dollar NZ$", animal: "Kiwi Bird 🥝", food: "Hangi 🍖", population: "5 million people",
    moreFacts: ["There are MORE sheep than people here!", "The kiwi bird can't fly."] },
  { code: "fj", name: "Fiji", continent: "oceania", capital: "Suva", language: "Fijian", hello: "Bula",
    funFact: "Fiji has over 300 islands with crystal blue water!", landmark: "Coral Coast",
    currency: "Dollar FJ$", animal: "Iguana 🦎", food: "Kokoda 🐟", population: "1 million people",
    moreFacts: ["Bula means hello AND wishes good health!", "Rugby is the national sport."] },
  { code: "pg", name: "Papua New Guinea", continent: "oceania", capital: "Port Moresby", language: "English", hello: "Halo",
    funFact: "Papua New Guinea has 800+ languages — more than any other country!", landmark: "Mount Wilhelm",
    currency: "Kina K", animal: "Bird of Paradise 🦚", food: "Mumu 🍖", population: "10 million people",
    moreFacts: ["The Bird of Paradise has incredible colorful feathers.", "Many tribes still live in the rainforest."] },

  // Antarctica (no country but special)
  { code: "aq", name: "Antarctica", continent: "antarctica", capital: "No capital", language: "No language", hello: "Brrr!",
    funFact: "Antarctica has no countries — just penguins and scientists!", landmark: "South Pole",
    currency: "No money", animal: "Emperor Penguin 🐧", food: "Frozen snacks ❄️", population: "About 1,000 scientists",
    moreFacts: ["It is the coldest place on Earth.", "The sun doesn't set for 6 months in summer!"] },
];

// Merge the core hand-curated set with the extended UN-195 pool so every
// downstream feature (map, quizzes, pre-render, sitemap) automatically
// covers all countries. De-duplicated on ISO code — core entries win.
import { COUNTRIES_EXTENDED } from "./countriesExtended";
const _seen = new Set(_CORE_COUNTRIES.map((c) => c.code));
const _extras = COUNTRIES_EXTENDED.filter((c) => !_seen.has(c.code));
export const COUNTRIES = [..._CORE_COUNTRIES, ..._extras];

// Feb 2026 cycle 43: flags now proxy through our backend. flagcdn.com
// was slow / rate-limited from many browsers, causing blank flag cards
// in Match Pairs and country tiles. The backend caches once to disk,
// so every subsequent client hit is instant and offline-resilient.
// Falls back automatically to a second CDN (hatscripts circle-flags)
// on the server side, and the frontend `<Flag />` component swaps to
// the regional-indicator emoji if even the proxy fails.
const _API_BASE = (typeof process !== "undefined" && process.env && process.env.REACT_APP_BACKEND_URL) || "";
export const flagUrl = (code) => {
  if (!code || typeof code !== "string") return "";
  return `${_API_BASE}/api/flag/${code.toLowerCase()}.png`;
};

// Feb 2026: country-scoped flag emoji derived from the ISO-2 code —
// pairs of regional-indicator symbols (Unicode 1F1E6 onwards). Fixes
// the "Country of the Day" bug where every Oceania country used to
// show 🦘 because the card was rendering the CONTINENT emoji. Falls
// back to a generic globe when the code is malformed.
export const flagEmoji = (code) => {
  if (!code || typeof code !== "string" || code.length !== 2) return "🌍";
  const A = 0x1F1E6;
  const base = "a".charCodeAt(0);
  const [a, b] = code.toLowerCase().split("");
  return String.fromCodePoint(A + (a.charCodeAt(0) - base), A + (b.charCodeAt(0) - base));
};

export const continentById = (id) => CONTINENTS.find((c) => c.id === id);

export const countriesByContinent = (id) => COUNTRIES.filter((c) => c.continent === id);
